import { EventEmitter, Component, ChangeDetectionStrategy, ChangeDetectorRef, Input, Output, NgModule } from '@angular/core';
import { breakpointBelow, ResponsiveService, B2CSharedResponsiveModule } from 'b2c-ui/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { tap } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { B2CNgzIconModule } from 'b2c-ui/ngz-icons';

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-announcement-banner.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * ##### Import this component individually to your module
 * `import { B2CAnnouncementBannerModule } from 'b2c-ui/announcement-banner';`
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'b2c-ui/core';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from 'ng-zorro-antd/grid';
import * as ɵngcc4 from 'ng-zorro-antd';

const _c0 = function (a0, a1) { return { "slide-up": a0, "is-mobile": a1 }; };
const _c1 = ["*"];
class B2CAnnouncementBannerComponent {
    /**
     * @param {?} responsiveService
     * @param {?} cdRef
     */
    constructor(responsiveService, cdRef) {
        this.responsiveService = responsiveService;
        this.cdRef = cdRef;
        /**
         * @ignore
         */
        this._isMobile = false;
        /**
         * Set The Visibility of The Notification
         */
        this.show = true;
        this.close = new EventEmitter();
        this.responsiveService
            .observeBoolean(breakpointBelow.sm)
            .pipe(tap((/**
         * @param {?} matched
         * @return {?}
         */
        (matched) => {
            this.isMobile = matched;
            this.cdRef.markForCheck();
        })))
            .subscribe();
    }
    /**
     * Set The Mobile View for The Notification
     * @param {?} value
     * @return {?}
     */
    set isMobile(value) {
        this._isMobile = coerceBooleanProperty(value);
    }
    /**
     * @return {?}
     */
    get isMobile() {
        return this._isMobile;
    }
    /**
     * @return {?}
     */
    onClose() {
        this.show = !this.show;
        this.close.emit();
    }
}
B2CAnnouncementBannerComponent.ɵfac = function B2CAnnouncementBannerComponent_Factory(t) { return new (t || B2CAnnouncementBannerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ResponsiveService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
B2CAnnouncementBannerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: B2CAnnouncementBannerComponent, selectors: [["b2c-announcement-banner"]], inputs: { show: "show" }, outputs: { close: "close" }, ngContentSelectors: _c1, decls: 11, vars: 4, consts: [[1, "b2c-announcement-banner", 3, "ngClass"], ["announcementBanner", ""], ["nz-row", "", 1, "b2c-announcement-inner", "container"], ["nz-col", "", "nzSpan", "23", 1, "b2c-announcement-content"], [1, "mb-0"], [1, "b2c-notification-icon"], ["nz-icon", "", "nzType", "notification", "nzTheme", "fill"], ["nz-col", "", "nzSpan", "1", 1, "b2c-close-icon", "text-right"], ["nz-icon", "", "nzType", "close", "nzTheme", "outline", 3, "click"]], template: function B2CAnnouncementBannerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "p", 4);
        ɵngcc0.ɵɵelementStart(5, "span", 5);
        ɵngcc0.ɵɵelement(6, "i", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "span");
        ɵngcc0.ɵɵprojection(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 7);
        ɵngcc0.ɵɵelementStart(10, "i", 8);
        ɵngcc0.ɵɵlistener("click", function B2CAnnouncementBannerComponent_Template_i_click_10_listener() { return ctx.onClose(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(1, _c0, !ctx.show, ctx.isMobile));
    } }, directives: [ɵngcc2.NgClass, ɵngcc3.NzRowDirective, ɵngcc3.NzColDirective, ɵngcc4.NzIconDirective], encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
B2CAnnouncementBannerComponent.ctorParameters = () => [
    { type: ResponsiveService },
    { type: ChangeDetectorRef }
];
B2CAnnouncementBannerComponent.propDecorators = {
    show: [{ type: Input }],
    close: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CAnnouncementBannerComponent, [{
        type: Component,
        args: [{
                selector: 'b2c-announcement-banner',
                template: "<div\r\n  class=\"b2c-announcement-banner\"\r\n  [ngClass]=\"{'slide-up': !show, 'is-mobile': isMobile}\"\r\n  #announcementBanner\r\n>\r\n  <div nz-row class=\"b2c-announcement-inner container\">\r\n    <div nz-col nzSpan=\"23\" class=\"b2c-announcement-content\">\r\n      <p class=\"mb-0\">\r\n        <span class=\"b2c-notification-icon\">\r\n          <i nz-icon nzType=\"notification\" nzTheme=\"fill\"></i>\r\n        </span>\r\n        <span>\r\n          <ng-content></ng-content>\r\n        </span>\r\n      </p>\r\n    </div>\r\n    <div nz-col nzSpan=\"1\" class=\"b2c-close-icon text-right\">  \r\n      <i nz-icon nzType=\"close\" nzTheme=\"outline\" (click)=\"onClose()\"></i>\r\n    </div>\r\n  </div>\r\n</div>\r\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc1.ResponsiveService }, { type: ɵngcc0.ChangeDetectorRef }]; }, { show: [{
            type: Input
        }], close: [{
            type: Output
        }] }); })();
if (false) {
    /**
     * @ignore
     * @type {?}
     * @private
     */
    B2CAnnouncementBannerComponent.prototype._isMobile;
    /**
     * Set The Visibility of The Notification
     * @type {?}
     */
    B2CAnnouncementBannerComponent.prototype.show;
    /** @type {?} */
    B2CAnnouncementBannerComponent.prototype.close;
    /**
     * @type {?}
     * @private
     */
    B2CAnnouncementBannerComponent.prototype.responsiveService;
    /**
     * @type {?}
     * @private
     */
    B2CAnnouncementBannerComponent.prototype.cdRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-announcement-banner.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class B2CAnnouncementBannerModule {
}
B2CAnnouncementBannerModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: B2CAnnouncementBannerModule });
B2CAnnouncementBannerModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function B2CAnnouncementBannerModule_Factory(t) { return new (t || B2CAnnouncementBannerModule)(); }, imports: [[CommonModule, B2CNgzIconModule, NzGridModule, B2CSharedResponsiveModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(B2CAnnouncementBannerModule, { declarations: function () { return [B2CAnnouncementBannerComponent]; }, imports: function () { return [CommonModule, B2CNgzIconModule, NzGridModule, B2CSharedResponsiveModule]; }, exports: function () { return [B2CAnnouncementBannerComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CAnnouncementBannerModule, [{
        type: NgModule,
        args: [{
                declarations: [B2CAnnouncementBannerComponent],
                exports: [B2CAnnouncementBannerComponent],
                imports: [CommonModule, B2CNgzIconModule, NzGridModule, B2CSharedResponsiveModule]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-ui-announcement-banner.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { B2CAnnouncementBannerComponent, B2CAnnouncementBannerModule };


//# sourceMappingURL=b2c-ui-announcement-banner.js.map